<template>
<div class="view-details-header bg-primary position-relative">
		<div class="header-image" v-if="paperData.image">
			<img :src="paperData.image" :alt="paperData.name">
			</div>
		<div class="header-overlay"></div>
		<div class="container container--narrow position-relative pdt-30 pdb-30 pdl-16 pdr-16">
						<div class="t-headline11 t-color-whiteHigh font-m">
										{{paperData.name}}
						</div>
						<div class="t-body6 t-color-whiteHigh font-r pdt-16 pdb-12" v-if="paperData.category">
										{{paperData.category.text}}
										{{paperData.category.child ? ' > ' + paperData.category.child.text : ''}}
						</div>
						<div class="t-body6 t-color-whiteHigh font-r pdb-12" v-if="paperData.level">
										{{paperData.level.text}}
						</div>
						<div class="mdc-chip-set banner--chip chip--outlined" role="grid" v-if="paperData.tags.length">
							<div class="mdc-chip " role="row" v-for="(tag, index) in paperData.tags" :key="index">
								<div class="mdc-chip__ripple d-none"></div>
								<span role="gridcell">
											<span class="mdc-chip__text t-body4 font-r">#{{tag.name}}</span>
								</span>
							</div>
										<!-- <div class="mdc-chip" role="row">
														<div class="mdc-chip__ripple"></div>
														<span role="gridcell">
																		<span class="mdc-chip__text">테그1</span>
														</span>
										</div>
										<div class="mdc-chip" role="row">
														<div class="mdc-chip__ripple"></div>
														<span role="gridcell">
																		<span class="mdc-chip__text">테그1</span>
														</span>
										</div> -->
						</div>
						<div class="d-flex align-items-baseline justify-content-between mgt-24" v-if="paperData.goods && !examineeId">
							<div class="d-flex align-items-baseline" v-if="isCharged">
								<div class="t-body-6 pdr-4 t-color-whiteHigh">{{paperData.goods.currency.key || 'USD'}}</div>
								<div class="t-headline5 pdr-8  t-color-whiteHigh font-b">{{$n(paperData.goods.paymentPrice)}}</div>
								<div class="t-body1 t-color-whiteMedium t-line-through-red" v-if="paperData.goods.paymentPrice !== paperData.goods.price">{{$n(paperData.goods.price)}}</div>
							</div>
							<div class="t-headline5 pdr-8  t-color-whiteHigh font-b" v-else>{{$t('1010')}}</div>
										<!-- <div class="t-body1 t-color-whiteMedium font-r">(정원 67 / 123)</div> -->
						</div>
						<div v-if="paperData.goods">
							<div v-if="todayDate > endDate">
								<button class="mdc-button mdc-button--raised bg-disableBtn t-color-disableBtnText w-full mgt-24"
										disabled >
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{$t('3080')}}</span>
								</button>
									
							</div>
							<div v-else-if="!examineeId">
								<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full mgt-24"
										v-if="isCharged" @click="buyExam()" @keypress="buyExam()" tabindex="0">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{$t('1002')}}</span>
								</button>
									<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full mgt-24"
										v-else @click="buyExam()" @keypress="buyExam()" tabindex="0">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body2 font-r">{{$t('1011')}}</span>
								</button>
							</div>
							<div v-else>
								<div v-for="(action, index) in actions" :key="index">
									<button class="mdc-button w-full mgt-24" 
									:class="{'bg-disableBtn disabled  t-color-disableBtnText':setButtonDisabled(action) ,'mdc-button--raised bg-mainBtn t-color-mainBtnText':!setButtonDisabled(action)}" tabindex="0" @click="examAction(action)" @keypress="examAction(action)"
									:disabled="setButtonDisabled(action)" v-if=" action.action != 'can_re_start' && action.action != 'after_confirm' ">
												<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
								</button>
								</div>
							</div>
						</div>
		</div>
</div>

</template>

<script>
import httpService from '@/api/httpService'
import loginApi from '@/api/loginApi.js'
import degreeApi from '@/api/degreeApi.js'
import salesApi from '@/api/salesApi.js'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'
import {MDCChipSet} from '@material/chips';
export default {
	props: ['paperData','examineeId','actions','todayDate', 'endDate'],
	data() {
		return {
			price: 0
		}
	},
	mixins: [examMixin],

	mounted() {
		// this.price = this.paperData.price
	   this.setMaterialUi()
	   const chipSetEl = document.querySelector('.mdc-chip-set');
	   const chipSet = new MDCChipSet(chipSetEl);
		
	},

	computed: {
		isCharged() {
			return this.paperData.goods ? !!this.paperData.goods.paymentPrice : false
		}
	},

	methods: {
		async buyExam() {
			// console.log(await this.checkLogin());
			let authStatus = await this.checkLogin()
			if (authStatus) {
				salesApi.salesGoodsPurchased({goodsId: this.paperData.goods.id,fetchType:'EXAM'}).then((response) => {
					let purchasedData = response.data.data
					// console.log('purchasedData',purchasedData); return
					localStorage.setItem('productId',this.paperData.id)

					if (purchasedData.length) {
						this.$router.push({
							name: 'SalesDuplicate', 
							params: {goodsid: this.paperData.goods.id}, 
							query: this.$route.query
						})
						return false
					}

					this.$router.push({
						name: 'SalesInformation', 
						params: {goodsid: this.paperData.goods.id}, 
						query: this.$route.query
					})
					
				}).catch((err) => {

				})
				
			}else {
				this.moveLogin()
			}
		},

		checkLogin() {
			// httpService.setAuthInHeader(localStorage.getItem('token'))
			return new Promise((resolve, reject) => {
				loginApi.validToken().then((response) => {
					resolve(true)
				}).catch((err) => {
					resolve(false)
				})
			})
			

		},

		moveLogin() {
			const loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.fullPath)}`
			this.$router.push(loginPath)
		},


		setButtonActionName(action) {
			//before_start : ~부터 응시가능
			//can_start : 응시
			//can_re_start : 재응시
			//before_confirm : ~부터 결과확인 가능
			//open_confirm : 결과확인
			let buttonName = ''
			if (action.action === 'before_start') {
				buttonName = this.$t('531', {str: this.$moment(action.data.application_start_time).format('L')}) //  + '{날짜}부터 응시가능'
			}else if (action.action === 'can_start') {
				//buttonName = this.$t('50008') //'응시'
				buttonName = this.$t('524') //'응시'
			}else if (action.action === 'can_re_start') {
				buttonName = this.$t('50009') //재응시'
			}else if (action.action === 'before_confirm') {
				buttonName = this.$t('3080', {str: this.$moment(action.data.confirm_start_time).format('L')}) // '~부터 결과확인 가능'
			}else if (action.action === 'open_confirm') {
				buttonName = this.$t('50012') //'결과확인'
			}
			else if (action.action === 'after_confirm') {
				buttonName = this.$t('3080', {str: this.$moment(action.data.confirm_start_time).format('L')}) // '~부터 결과확인 가능'
			}
			else if (action.action === 'after_end') {
				buttonName = this.$t('3080', {str: this.$moment(action.data.confirm_start_time).format('L')}) // '~부터 결과확인 가능'
			}
			return buttonName
		},

		setButtonDisabled(action) {
			return action.action === 'before_start' || action.action === 'before_confirm' || action.action === 'after_end' ? true : false
		},

		examAction(action) {
			if (action.action === 'can_start' || action.action === 'can_re_start') {
				this.startExam()
			}else if (action.action === 'open_confirm') {
				//this.startExam()
				this.moveExamResult()
				
			}
		},

		moveExamResult() {
			let query = this.$route.query;
			query.type='independent'
			this.$router.push({
				name: 'IndependentExamIntro', 
				query: query
			})
		},

		startExam() {
			let query = this.$route.query;
			query.type='independent'
			this.$router.push({
				name: 'IndependentExamIntro', 
				query: query
				// params: {learnId: this.$route.params.learnId},
				// query: this.$route.query
			})
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
			
		},
	},
	



}
</script>

<style>

</style>
